import { Card, CardContent } from '../ui/card';
import { cn } from '../ui/utils';

const sectionPalettes = [
  {
    accent: 'bg-blue-600',
    badge: 'bg-blue-100 text-blue-700',
    frame: 'border-blue-100 bg-white',
  },
  {
    accent: 'bg-emerald-600',
    badge: 'bg-emerald-100 text-emerald-700',
    frame: 'border-emerald-100 bg-white',
  },
  {
    accent: 'bg-sky-600',
    badge: 'bg-sky-100 text-sky-700',
    frame: 'border-sky-100 bg-white',
  },
  {
    accent: 'bg-slate-700',
    badge: 'bg-slate-100 text-slate-700',
    frame: 'border-slate-200 bg-white',
  },
];

export function Benefits({ copy, benefits }) {
  return (
    <section className="space-y-8">
      <div className="max-w-3xl">
        <p className="text-sm font-semibold uppercase tracking-[0.24em] text-blue-700">
          {copy.eyebrow}
        </p>
        <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          {copy.title}
        </h2>
        <p className="mt-4 text-base leading-7 text-slate-600">
          {copy.description}
        </p>
      </div>

      <div className="space-y-6">
        {benefits.map((benefit, index) => {
          const palette = sectionPalettes[index % sectionPalettes.length];
          const isReverse = index % 2 === 1;

          return (
            <Card
              key={benefit.title}
              className={cn(
                'overflow-hidden rounded-lg border border-slate-200 bg-slate-50 shadow-sm',
                'transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg'
              )}
            >
              <CardContent className="p-5 sm:p-7 lg:p-8">
                <article className="grid gap-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:items-center lg:gap-10">
                  <div className={cn(isReverse && 'lg:order-2')}>
                    <span className={cn('inline-flex rounded-full px-3 py-1 text-xs font-semibold', palette.badge)}>
                      {copy.itemLabel} {index + 1}
                    </span>
                    <div className={cn('mt-5 h-1 w-16 rounded-full', palette.accent)} />
                    <h3 className="mt-5 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
                      {benefit.title}
                    </h3>
                    <p className="mt-4 max-w-xl text-base leading-7 text-slate-600">
                      {benefit.description}
                    </p>
                  </div>

                  <div className={cn(isReverse && 'lg:order-1')}>
                    <div className={cn('rounded-lg border p-2 shadow-lg sm:p-3', palette.frame)}>
                      <img
                        src={benefit.image.src}
                        alt={benefit.image.alt}
                        className="aspect-[16/9] w-full rounded-md object-contain shadow-lg"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </article>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </section>
  );
}
